//refactoring

const locationPathNameSplitted = window.location.pathname.split('/')
const smsRadarServiceIds = [1356, 1357]

const smsRadarServiceId =
  locationPathNameSplitted[locationPathNameSplitted.length - 1]

export const isSmsRadarServiceId = smsRadarServiceIds.includes(
  +smsRadarServiceId,
)
  ? smsRadarServiceId
  : null

const originalDocumentTitle = document.title

export const documentTitle = isSmsRadarServiceId
  ? 'Api.az'
  : originalDocumentTitle

export const SERVICE_PATH = '/frames/:id'
export const SERVICE_PATH_SMS_RADAR = `/frames/${isSmsRadarServiceId}`
export const SERVICE_PATH_LANG_PARAM = '/frames/:lang/:id'
export const SERVICE_PATH_LANG_PARAM_SMS_RADAR = `/frames/:lang/${isSmsRadarServiceId}`
export const CONFIRMATION_PATH = '/frames/confirmation/:id'
export const CONFIRMATION_PATH_LANG_PARAM = '/frames/:lang/confirmation/:id'
export const CHECK_PATH = '/frames/check'
export const CHECK_PATH_SMS_RADAR = `/frames/check/${isSmsRadarServiceId}`
export const CHECK_PATH_LANG_PARAM = '/frames/:lang/check'
export const CHECK_PATH_LANG_PARAM_SMS_RADAR = `/frames/:lang/check/${isSmsRadarServiceId}`

export const USERAGENT = navigator.userAgent.toLowerCase()
